import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VueRouter from 'vue-router';
import App from './App.vue';
import {routes} from './routes.js';
import {messages} from './i18n.js';
import VueMeta from 'vue-meta'
import firebase from "firebase/app";
import "firebase/database";
import "firebase/storage";

/*import MainPage from './components/site/Main.vue';
import Navbar from './components/site/Navbar.vue';
import Contact from './components/site/Contact.vue';
import Club from './components/site/Club.vue';
import News from './components/site/News.vue';
import Field from './components/site/Field.vue';
import NewsSubpage from './components/site/News_page.vue';*/

// GLOBAL
//Vue.component( 'navbar', Navbar );

/*const firebaseConfig = {
    apiKey: "AIzaSyCYDI2kxTXE6fXavSz838TSG_1TEnfqyD8",
    authDomain: "csoda-a6bbc.firebaseapp.com",
    databaseURL: "https://csoda-a6bbc.firebaseio.com",
    projectId: "csoda-a6bbc",
    storageBucket: "csoda-a6bbc.appspot.com",
    messagingSenderId: "13464711115",
    appId: "1:13464711115:web:8557e3908cf41a315ed04e",
    measurementId: "G-WSX8029QRF"
};*/

var firebaseConfig = {
    apiKey: "AIzaSyAzEcZN0_6Nf0wcFKzQrdHwUQ76hn3WsRU",
    authDomain: "csoda-7daec.firebaseapp.com",
    databaseURL: " https://csoda-7daec-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "csoda-7daec",
    storageBucket: "csoda-7daec.appspot.com",
    messagingSenderId: "330544783020",
    appId: "1:330544783020:web:8e09c7d97944b79793c909"
}

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

//const db = firebase.database();
//const storage = firebase.storage();

Vue.use(VueRouter);
Vue.use(VueI18n);
Vue.use(firebase);

Vue.use(VueMeta, {
  keyName: 'metaInfo',
  attribute: 'data-vmid'
});

const router = new VueRouter({
	routes,
	mode: 'history'
});

const i18n = new VueI18n({
	locale: "hu",
	messages
});

new Vue({
	el: '#app',
	router,
	i18n,
	// LOCALY
	/*components: {
		'main-index' : MainPage,
		'contact' : Contact,
		'club' : Club,
		'news' : News,
		'field' : Field,
		'news_page' : NewsSubpage,
		'navbar' : Navbar
	},*/
	render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js